<template>
  <modal
    v-model="isProfileSelectorOpen"
    size="sm"
    title="Select Content Profile"
    :append-to-body="true"
    :dismiss-btn="false"
    :footer="false">
    <ContentProfileSelector
      v-if="!fetchingProfileChoices && !fetchingActiveProfile && !updatingAccountProfile"
      :profile-choices="profileChoices"
      :currently-active-profile-id="profileId"
      @cpselect:confirmed="onConfirm"
      @cpselect:canceled="closeModal"
    />
    <p class="loading-active-profile text-muted" v-if="fetchingActiveProfile || updatingAccountProfile"><i class="fa fa-circle-o-notch fa-spin"/> Setting profile...</p>
    <p class="loading-profiles text-muted" v-if="fetchingProfileChoices"><i class="fa fa-circle-o-notch fa-spin"/> Loading profiles...</p>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ContentProfileSelector from './ContentProfileSelector'
import { getProfiles } from '../api'

export default {
  name: 'ContentProfileSelectorContainer',
  components: {
    ContentProfileSelector
  },
  data() {
    return {
      fetchingProfileChoices: false,
      profileChoices: []
    }
  },
  computed: {
    ...mapState('user', {
      userUuid: state => state.user.uuid
    }),
    ...mapGetters('contentProfile', ['profileId']),
    ...mapState('contentProfile', [
      'fetchingActiveProfile',
      'updatingAccountProfile',
      'isProfileSelectorOpen'
    ])
  },
  methods: {
    ...mapActions('contentProfile', ['setActiveProfileById', 'updateAccountProfileId']),
    ...mapMutations('contentProfile', ['setIsProfileSelectorOpen']),

    async fetchProfileChoices() {
      this.fetchingProfileChoices = true
      let profiles = await getProfiles()
      this.fetchingProfileChoices = false
      this.profileChoices = profiles
    },
    async onConfirm(profileId) {
      if (!profileId) {
        this.closeModal()
        return
      }

      await Promise.all([
        this.setActiveProfileById(profileId),
        this.updateAccountProfileId({
          userUuid: this.userUuid,
          profileId
        })
      ])
      this.closeModal()
    },
    closeModal() {
      this.setIsProfileSelectorOpen(false)
    }
  },
  created() {
    this.fetchProfileChoices()
  }
}
</script>
